module.exports = __webpack_public_path__ + "static/media/power_circle.93cbb705.svg";